import { camelCase } from 'lodash'

export const FOCUS_PROPS = {
    alberta: { latitude: 54.9333, longitude: -116.5765, zoom: 5 },
    bc: { latitude: 54.7267, longitude: -127.6476, zoom: 5 },
    manitoba: { latitude: 54.7609, longitude: -98.8139, zoom: 5 },
    ontario: { latitude: 50.2538, longitude: -85.3232, zoom: 4.8 },
    quebec: { latitude: 52.939, longitude: -73.5491, zoom: 4.8 },
    saskatchewan: { latitude: 54.9399, longitude: -104.4509 },
    eastern: { latitude: 51.2418, longitude: -63.5986, zoom: 4.9 },
    northern: { latitude: 66.9586, longitude: -104.3468, zoom: 4 },

    canada: { latitude: 54.9399, longitude: -104.4509, zoom: 4 }
}

export const FOCUS_PROPS2 = {
    AB: { latitude: 54.9333, longitude: -116.5765, zoom: 5 },
    BC: { latitude: 54.7267, longitude: -127.6476, zoom: 5 },
    MB: { latitude: 54.7609, longitude: -98.8139, zoom: 5 },
    NB: { latitude: 51.2418, longitude: -63.5986, zoom: 5.8 },
    NL: { latitude: 51.2418, longitude: -63.5986, zoom: 5.8 },
    NS: { latitude: 51.2418, longitude: -63.5986, zoom: 5.8 },
    NU: { latitude: 66.9586, longitude: -104.3468, zoom: 4 },
    ON: { latitude: 50.2538, longitude: -85.3232, zoom: 4.8 },
    PE: { latitude: 51.2418, longitude: -63.5986, zoom: 5.8 },
    QC: { latitude: 52.939, longitude: -73.5491, zoom: 4.8 },
    SK: { latitude: 54.9399, longitude: -104.4509 },
    YT: { latitude: 66.9586, longitude: -104.3468, zoom: 4 },
}


export const icon = (vendor, size = 'sm') => {
    const icons = {
        automotiveDealers: { 
            default: { sm: '/images/google-maps-purple-round.png', lg: '/images/google-maps-purple.png' },
            // VOLKSWAGEN: '/images/volkswagen.png',
            // FORD: '/images/ford.png',
            // LAND_ROVERRANGE_ROVER: '/images/landRangeRover.png',
            // KIA: '/images/kia.png'
        },
        automotiveAsp: { default: { sm: '/images/google-maps-blue-round.png', lg: '/images/google-maps-blue.png' } },
        automotivePartsSupplies: { default: { sm: '/images/google-maps-green-round.png', lg: '/images/google-maps-green.png' } },
        fastLube: { default: { sm: '/images/google-maps-babyblue-round.png', lg: '/images/google-maps-babyblue.png' } },
        pbe: { default: { sm: '/images/google-maps-yellow-round.png', lg: '/images/google-maps-yellow.png' } },
        tireDealers: {
            default: { sm: '/images/google-maps-red-round.png', lg: '/images/google-maps-red.png' },
            // FOUNTAIN_TIRE: '/images/fountainTire.png',
            // KAL_TIRE: '/images/kalTire.png'
        },
        truckTrailerRvRepair: {
            default: { sm: '/images/google-maps-orange-round.png', lg: '/images/google-maps-orange.png' }
        },
        grey: {
            default: { sm: '/images/google-maps-grey-round.png', lg: '/images/google-maps-grey.png' }
        }
    }

    const defaultIcon = { sm: '/images/google-maps-red-round.png', lg: '/images/google-maps-red.png' }

    if (!vendor.channelSegment) return defaultIcon

    // console.log(vendor.channelSegment.replace(" ","_").replace(/[^A-Za-z_]/g,'').toUpperCase())

    const channelSegment = vendor.channelSegment ? camelCase(vendor.channelSegment) : null
    const mapType = vendor.mapType ? camelCase(vendor.mapType) : null
    
    if (icons[channelSegment] && icons[channelSegment][mapType]) return icons[channelSegment][mapType]
    if (icons[channelSegment]) return size === 'sm' ? icons[channelSegment].default.sm : icons[channelSegment].default.lg
    return size === 'sm' ? defaultIcon.sm : defaultIcon.lg

}